export default __webpack_public_path__ + "static/media/logiciel.7f96c1b0.png";